import API from '..'

export const UsersAPI = {
  showUser: (id: string) => {
    return API.get('/fanfou/show_user', { params: { id } })
  },
}
